import {
    apiRequest,
    provinsiCreate,
    provinsiAll
} from "../../../../../services/adapters/master/provinsiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", provinsiCreate, {
            body: query
        }, true)
    }
    fetchProvince = async (query) => {
        return await apiRequest("get", provinsiAll, {
            param: query
        }, true)
    }

}

export default CreateRepository